export const LOGIN_TRANSLATIONS = {
  en: {
    title: "Ama Kalakara",
    subtitle: "Official access portal for cultural troupe registration and administration.",
    officialBadge: "Official Government Access",
    signinTitle: "DEPARTMENT LOGIN",
    signinSubtitle: "Enter your credentials to manage cultural resources.",
    mobileSigninTitle: "MOBILE LOGIN",
    mobileSigninSubtitle: "Sign in with your registered 10-digit mobile number and password.",
    loginModeUsername: "Username",
    loginModeMobile: "Mobile Number",
    loginModeDepartment: "Department Login",
    ractBadge: "Registered R.A. / C.T. access",
    loginModeRact: "(RA / CT) Login",
    mobileLabel: "Mobile Number",
    mobilePlaceholder: "Enter 10-digit mobile number",
    mobileRequired: "Mobile number is required",
    mobileInvalid: "Enter a valid 10-digit mobile number",
    usernameLabel: "Username",
    usernamePlaceholder: "Enter your Username",
    usernameRequired: "Username is required",
    usernameInvalid: "Enter a valid username format",
    invalidUsernameForLoginType: "Invalid username for the selected login type.",
    invalidUsernameMode: "Invalid Username for the Selected Login Mode.",
    invalidUsernameFormatForLoginType: "Invalid username format for the selected login type.",
    invalidCredentials: "Invalid credentials. Please check your username and password and try again.",
    // The 5 / 15 here mirror MAX_LOGIN_ATTEMPTS and LOCK_DURATION_MINUTES in
    // backend auth.service.ts — update both together if those change.
    tooManyAttempts: "Too many failed login attempts. Your account is locked for 15 minutes.",
    accountLocked: "Account temporarily locked after 5 failed attempts. Please try again in 15 minutes.",
    ctNotSelectedYet: "Your CT has not been selected yet. Login access is granted only after the jury selection process is complete.",
    ctDeactivated: "This cultural troupe has been deactivated. Please register a new troupe with the same mobile number.",
    serverError: "Server issue. Please try again after some time.",
    unexpectedError: "An unexpected login error occurred. Please try again.",
    correctFormErrors: "Please correct the errors in the form before submitting.",
    dismissingAlerts: "Dismissing Alerts",
    loginSuccess: "Login successful",
    passwordLabel: "Password",
    passwordPlaceholder: "Enter password",
    passwordRequired: "Password is required",
    passwordMinlength: "Password must be at least 8 characters",
    passwordFormatInvalid: "Password must be at least 8 characters, include at least 1 lowercase, 1 uppercase, 1 number, and 1 special character.",
    forgotPassword: "Forgot password?",
    passwordNotice: "Never share your password. Ama Kalakara staff will never ask for it.",
    signInBtn: "Sign In Securely",
    sslSecured: "SSL Secured",
    officialGovtPortal: "Official Government Portal",
    encrypted: "256-bit Encrypted",
    backToHome: "Back to Home",
    verificationTitle: "Official Verification",
    verificationDesc: "Government of Odisha verified access. This portal is restricted to authorized personnel and registered cultural agencies.",
    needHelpTitle: "Need Help?",
    needHelpDesc: "Our administrative team is available Mon–Fri and 1st Sat - 3rd Sat, 10:00 AM – 6:00 PM (IST).",
    contactHelpdesk: "Contact Helpdesk",
    adminSupportTitle: "Administrative Support",
    adminSupportDesc: "For login issues or password resets, contact the Ama Kalakara Helpdesk or your district nodal officer.",
    footerCopy: "© 2026 Odia Language, Literature & Culture Department, Government of Odisha",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    accessibility: "Accessibility"
  },
  or: {
    title: "ଆମ କଳାକାର",
    subtitle: "ସାଂସ୍କୃତିକ ଦଳ ପଞ୍ଜୀକରଣ ଏବଂ ପ୍ରଶାସନ ପାଇଁ ସରକାରୀ ପ୍ରବେଶ ପୋର୍ଟାଲ |",
    officialBadge: "ସରକାରୀ ପ୍ରବେଶ",
    ractBadge: "ପଞ୍ଜୀକୃତ ଆରଏ / ସିଟି ଲଗଇନ୍",
    signinTitle: "ବିଭାଗ ଲଗଇନ୍",
    signinSubtitle: "ସାଂସ୍କୃତିକ ଉତ୍ସ ପରିଚାଳନା କରିବାକୁ ଆପଣଙ୍କର ପରିଚୟପତ୍ର ପ୍ରବେଶ କରନ୍ତୁ |",
    mobileSigninTitle: "ମୋବାଇଲ୍ ଲଗଇନ୍",
    mobileSigninSubtitle: "ଆପଣଙ୍କର ପଞ୍ଜିକୃତ ୧୦ ଅଙ୍କର ମୋବାଇଲ୍ ନମ୍ବର ଏବଂ ପାସୱାର୍ଡ ସହିତ ସାଇନ୍ ଇନ୍ କରନ୍ତୁ ।",
    loginModeUsername: "ୟୁଜରନେମ୍",
    loginModeMobile: "ମୋବାଇଲ୍ ନମ୍ବର",
    loginModeDepartment: "ବିଭାଗ ଲଗଇନ୍",
    loginModeRact: "(ଆରଏ / ସିଟି) ଲଗଇନ୍",
    mobileLabel: "ମୋବାଇଲ୍ ନମ୍ବର",
    mobilePlaceholder: "୧୦ ଅଙ୍କର ମୋବାଇଲ୍ ନମ୍ବର ଦିଅନ୍ତୁ",
    mobileRequired: "ମୋବାଇଲ୍ ନମ୍ବର ଆବଶ୍ୟକ",
    mobileInvalid: "ବୈଧ ୧୦ ଅଙ୍କର ମୋବାଇଲ୍ ନମ୍ବର ଦିଅନ୍ତୁ",
    usernameLabel: "ୟୁଜରନେମ୍",
    usernamePlaceholder: "ଆପଣଙ୍କର ୟୁଜରନେମ୍ ପ୍ରବେଶ କରନ୍ତୁ",
    usernameRequired: "ୟୁଜରନେମ୍ ଆବଶ୍ୟକ ଅଟେ |",
    usernameInvalid: "ବୈଧ ୟୁଜରନେମ୍ ପ୍ରବେଶ କରନ୍ତୁ",
    invalidUsernameForLoginType: "ଚୟନିତ ଲଗଇନ୍ ପ୍ରକାର ପାଇଁ ଅବୈଧ ୟୁଜରନେମ୍",
    invalidUsernameMode: "ଚୟନିତ ଲଗଇନ୍ ମୋଡ୍ ପାଇଁ ଅବୈଧ ୟୁଜରନେମ୍",
    invalidUsernameFormatForLoginType: "ଚୟନିତ ଲଗଇନ୍ ପ୍ରକାର ପାଇଁ ଅବୈଧ ୟୁଜରନେମ୍ ଫର୍ମାଟ୍",
    invalidCredentials: "ଅବୈଧ ପ୍ରମାଣପତ୍ର ଦୟାକରି ଆପଣଙ୍କର ୟୁଜରନେମ୍ ଏବଂ ପାସୱାର୍ଡ ଯାଞ୍ଚ କରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ",
    tooManyAttempts: "ଅତ୍ୟଧିକ ଭୁଲ ଲଗଇନ୍ ଚେଷ୍ଟା। ଆପଣଙ୍କ ଆକାଉଣ୍ଟ ୧୫ ମିନିଟ୍ ପାଇଁ ଅବରୁଦ୍ଧ ହୋଇଛି।",
    accountLocked: "୫ ଥର ଭୁଲ ଚେଷ୍ଟା ପରେ ଆକାଉଣ୍ଟ ସାମୟିକ ଭାବେ ଅବରୁଦ୍ଧ। ଦୟାକରି ୧୫ ମିନିଟ୍ ପରେ ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।",
    ctNotSelectedYet: "ଆପଣଙ୍କ ସିଟି ଏପର୍ଯ୍ୟନ୍ତ ମନୋନୀତ ହୋଇନାହିଁ। ଜୁରୀ ମନୋନୟନ ପ୍ରକ୍ରିୟା ସମ୍ପୂର୍ଣ୍ଣ ହେଲା ପରେ ହିଁ ଲଗଇନ୍ ପ୍ରବେଶ ମିଳିବ।",
    ctDeactivated: "ଏହି ସାଂସ୍କୃତିକ ଦଳକୁ ନିଷ୍କ୍ରିୟ କରାଯାଇଛି। ଦୟାକରି ସମାନ ମୋବାଇଲ୍ ନମ୍ବରରେ ଏକ ନୂଆ ଦଳ ପଞ୍ଜିକରଣ କରନ୍ତୁ।",
    serverError: "ସର୍ଭର ସମସ୍ୟା। ଦୟାକରି କିଛି ସମୟ ପରେ ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ",
    unexpectedError: "ଏକ ଅପ୍ରତ୍ୟାଶିତ ତ୍ରୁଟି ଘଟିଛି। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ",
    correctFormErrors: "ଦୟାକରି ସବମିଟ୍ କରିବା ପୂର୍ବରୁ ଫର୍ମରେ ଥିବା ତ୍ରୁଟିଗୁଡ଼ିକୁ ସଂଶୋଧନ କରନ୍ତୁ",
    dismissingAlerts: "ଖାରଜ କରିବାର କାରଣ",
    loginSuccess: "ଲଗଇନ୍ ସଫଳ ହେଲା",
    passwordLabel: "ପାସୱାର୍ଡ",
    passwordPlaceholder: "ପାସୱାର୍ଡ ଦିଅନ୍ତୁ",
    passwordRequired: "ପାସୱାର୍ଡ ଆବଶ୍ୟକ ଅଟେ |",
    passwordMinlength: "ପାସୱାର୍ଡ ଅତିକମରେ ୮ ଟି ଅକ୍ଷର ହେବା ଆବଶ୍ୟକ |",
    passwordFormatInvalid: "ପାସୱାର୍ଡ ଅତିକମରେ ୮ ଟି ଅକ୍ଷର ହେବା ଆବଶ୍ୟକ, ସେଥିରେ ଅତିକମରେ ୧ ଟି ଛୋଟ ଅକ୍ଷର (lowercase), ୧ ଟି ବଡ଼ ଅକ୍ଷର (uppercase), ୧ ଟି ସଂଖ୍ୟା ଏବଂ ୧ ଟି ସ୍ୱତନ୍ତ୍ର ଚିହ୍ନ (special character) ରହିବା ଉଚିତ୍",
    forgotPassword: "ପାସୱାର୍ଡ ଭୁଲିଗଲେ କି?",
    passwordNotice: "କେବେବି ନିଜର ପାସୱାର୍ଡ କାହା ସହିତ ସେୟାର କରନ୍ତୁ ନାହିଁ । ଆମ କଳାକାରର କର୍ମଚାରୀମାନେ ଏହାକୁ କେବେବି ମାଗିବେ ନାହିଁ ।",
    signInBtn: "ସୁରକ୍ଷିତ ଭାବେ ସାଇନ୍ ଇନ୍ କରନ୍ତୁ",
    sslSecured: "ଏସଏସଏଲ୍ (SSL) ସୁରକ୍ଷିତ",
    officialGovtPortal: "ସରକାରୀ ପୋର୍ଟାଲ୍",
    encrypted: "୨୫୬-ବିଟ୍ ଏନକ୍ରିପ୍ଟେଡ୍",
    backToHome: "ମୁଖ୍ୟ ପୃଷ୍ଠାକୁ ଫେରନ୍ତୁ",
    verificationTitle: "ସରକାରୀ ଯାଞ୍ଚ",
    verificationDesc: "ଓଡିଶା ସରକାରଙ୍କ ଯାଞ୍ଚ ପ୍ରବେଶ | ଏହି ପୋର୍ଟାଲ୍ କେବଳ ଅନୁମୋଦିତ କର୍ମଚାରୀ ଏବଂ ପଞ୍ଜୀକୃତ ସାଂସ୍କୃତିକ ସଂସ୍ଥା ପାଇଁ ସୀମିତ |",
    needHelpTitle: "ସାହାଯ୍ୟ ଦରକାର କି?",
    needHelpDesc: "ଆମର ପ୍ରଶାସନିକ ଦଳ ସୋମବାର-ଶୁକ୍ରବାର ଓ ପ୍ରଥମ ଶନିବାର - ତୁର୍ତ୍ୟୟ ଶନିବାର, ସକାଳ ୧୦:୦୦ ରୁ ସନ୍ଧ୍ୟା ୬:୦୦ (IST) ଉପଲବ୍ଧ |",
    contactHelpdesk: "ହେଲ୍ପଡେସ୍କ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ",
    adminSupportTitle: "ପ୍ରଶାସନିକ ସହାୟତା",
    adminSupportDesc: "ଲଗଇନ୍ ସମସ୍ୟା କିମ୍ବା ପାସୱାର୍ଡ ରିସେଟ୍ ପାଇଁ, ଆମ କଳାକାର ହେଲ୍ପଡେସ୍କ କିମ୍ବା ଆପଣଙ୍କ ଜିଲ୍ଲା ନୋଡାଲ ଅଧିକାରୀଙ୍କ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ |",
    footerCopy: "© ୨୦୨୬ ଓଡ଼ିଆ ଭାଷା, ସାହିତ୍ୟ ଏବଂ ସଂସ୍କୃତି ବିଭାଗ, ଓଡ଼ିଶା ସରକାର",
    privacyPolicy: "ଗୋପନୀୟତା ନୀତି",
    termsOfService: "ସେବା ସର୍ତ୍ତାବଳୀ",
    accessibility: "ସୁଗମତା"
  }
};
